// extracted by mini-css-extract-plugin
export var component = "CardLink-module--component--PAy41";
export var inert = "CardLink-module--inert--tJV2i";